export default "__VITE_ASSET__D0s4halF__"